import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import StatusCode from 'status-code-enum';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetManifest } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetManifestApi =
  (endpoint: string): GetManifest =>
  async (id: string) => {
    try {
      LogCannon.blast('GetManifestApi start', {
        endpoint,
        manifestId: id,
      });
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);
      const response = await axios.get(`${endpoint}/${id}`, config);
      LogCannon.blast('GetManifestApi success');
      return Promise.resolve(response.data);
    } catch (error: any) {
      /*
        422 = Invalid manifest
        404 = manifest doesn't exist
      */
      if (error.response) {
        LogCannon.error('GetManifestApi error', { error: error.response.data?.message });
        if (
          error.response.status === StatusCode.ClientErrorUnprocessableEntity ||
          error.response.status === StatusCode.ClientErrorNotFound
        ) {
          return Promise.reject({
            message: 'This session has expired or cannot be located. Please try again',
            requestId: error.response.data?.requestId,
            type: ErrorType.MANIFEST_ERROR,
          });
        } else {
          return Promise.reject({
            message: error.response.data?.message,
            requestId: error.response.data?.requestId,
            type: ErrorType.SYSTEM_ERROR,
          });
        }
      } else {
        LogCannon.error('GetManifestApi error', { error });
        return Promise.reject({
          message: error,
        });
      }
    }
  };
